import apiClient from './client';

/** 自我进化闭环（P12）API 客户端。 */

export type EvolutionRunStatus = 'running' | 'completed' | 'failed';
export type EvolutionDecision = 'accepted' | 'rolled_back';

export interface EvolutionRun {
  id: string;
  agent_id: string;
  suite_id: string;
  status: EvolutionRunStatus;
  rounds: number;
  max_rounds: number;
  baseline_profile_id: string | null;
  baseline_score: number | null;
  final_score: number | null;
  accepted_rounds: number;
  outcome: string | null;
  job_id: string | null;
  /** B23 模型切换告警：创建时生效 LLM 配置指纹（provider/model），取不到为 null */
  llm_fingerprint: string | null;
  /** B23 模型切换告警：记录指纹 vs 当前生效模型比较（drifted=true 时前端展示黄色告警条） */
  model_drift: { drifted: boolean; message: string | null };
  created_at: string | null;
  updated_at: string | null;
  finished_at: string | null;
}

export interface EvolutionDiffPayload {
  type: 'unified_diff';
  label: string;
  before: unknown;
  after: unknown;
  diff: string;
}

export interface EvolutionRound {
  id: string;
  run_id: string;
  round_no: number;
  candidate: Record<string, unknown> | null;
  diff: EvolutionDiffPayload | null;
  score_before: number | null;
  score_after: number | null;
  decision: EvolutionDecision;
  reason: string;
  created_profile_id: string | null;
  created_at: string | null;
}

export interface EvolutionRunCreatePayload {
  /** 内置评测套件 ID（与 suite_path 二选一） */
  suite_id?: string;
  /** suite JSON 文件路径（服务端路径） */
  suite_path?: string;
  max_rounds?: number;
}

export async function createEvolutionRun(
  agentId: string,
  payload: EvolutionRunCreatePayload,
): Promise<{ run: EvolutionRun; job_id: string }> {
  const res = await apiClient.post(`/agents/${agentId}/evolution-runs`, payload);
  return res.data;
}

export async function listEvolutionRuns(agentId: string): Promise<EvolutionRun[]> {
  const res = await apiClient.get(`/agents/${agentId}/evolution-runs`);
  return res.data;
}

export async function getEvolutionRun(runId: string): Promise<EvolutionRun> {
  const res = await apiClient.get(`/evolution-runs/${runId}`);
  return res.data;
}

export async function listEvolutionRounds(runId: string): Promise<EvolutionRound[]> {
  const res = await apiClient.get(`/evolution-runs/${runId}/rounds`);
  return res.data;
}
